<template>
    <div class="question">
        <h2>Hoeveel stroom verbruikt je bedrijf per jaar?</h2>
        <span class="description">Dit staat op het stroomverbruik overzicht van je energieleverancier.</span>
        <range-input noPaddingLeftSide="true" type="yearlyEnergyUsage" setter="setYearlyEnergyUsage"></range-input>
    </div>
</template>

<script>
import RangeInput from './helpers/range-input'

export default {
  name: 'Q2',
  components: {
    'range-input': RangeInput
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Q2.vue